import * as Sentry from "@sentry/react";

// Respect Do Not Track header
function isDNT() {
  return (
    navigator.doNotTrack === "1" ||
    window.doNotTrack === "1" ||
    navigator.msDoNotTrack === "1"
  );
}

/**
 * Track a domain event as a Sentry breadcrumb.
 * No-op when Do Not Track is enabled or Sentry is not initialised.
 *
 * @param {string} name  - event name, e.g. "round_started"
 * @param {object} props - arbitrary metadata
 */
export function trackEvent(name, props = {}) {
  if (isDNT()) return;
  Sentry.addBreadcrumb({
    category: "domain",
    message: name,
    data: props,
    level: "info",
  });
}
